// Simple input validation styling
export function styleInputValidation(inputElement, numericValue, min, max) {
  inputElement.classList.toggle("invalid-input", (numericValue < min || numericValue > max))
}

export function resetInputStyling(inputElement) {
  inputElement.classList.toggle("invalid-input", false)
}